import { A } from '@components/general/link';
import { LogoMain } from '@components/img/logo';
import Image from 'next/image';
import { FaFacebookF, FaLinkedin, FaYoutube } from 'react-icons/fa';
import Logo15Horizontal from '../assets/15/logo15_horizontal.svg';
import hero from '../assets/15/ribbon-cutting.jpg';
import { Button } from '../components/general/button';
import { BlueArch, InstagramIcon, InvertWhiteArch } from '../components/img/svgs';
import { Meta } from '../components/meta/meta';

export default function Anniversary() {
  return (
    <main>
      <Meta title="15th Anniversary" description="Beds for Kids 15th Anniversary Celebration" noFooter={true} />
      {/* Mobile */}
      <div className="relative flex flex-col items-center pt-[calc(var(--banner-height))] md:hidden">
        <Image className="w-[75vw] max-w-[350px]" src={Logo15Horizontal} alt="Beds for Kids 15th Anniversary Logo" />
        <div className="mt-6 text-center font-avenir text-2xl font-bold leading-9 text-blue-500">
          15th Anniversary Celebration <br />+ Warehouse Grand Opening
        </div>
        <Button
          size="xl"
          bType="primary"
          className="mt-6 bg-green-500 !text-xl hover:bg-green-600 focus:ring-green-500 disabled:bg-green-300"
          link={`https://secure.qgiv.com/for/bedsforkids/event/bedsforkids15/`}>
          Send Your RSVP
        </Button>
        <InvertWhiteArch className="left-0 right-0 top-0 z-[1] mb-[-20px]" />
      </div>
      {/* Desktop */}
      <div className="relative hidden flex-row items-center justify-center pt-[calc(var(--banner-height))] md:flex">
        <Image
          className="absolute left-0 z-10 ml-4 w-[165px]"
          src={Logo15Horizontal}
          alt="Beds for Kids 15th Anniversary Logo"
        />
        <div className="relative z-10 mx-[200px] min-h-[60px] text-center font-operetta text-4xl font-bold text-blue-500">
          Celebrating 15 Years of Furnishing Futures
        </div>
        <InvertWhiteArch className="absolute bottom-0 left-0 right-0 z-[1] mb-[-70px]" />
      </div>
      <section className="relative h-[70vh] w-full overflow-hidden">
        <Image
          alt="Beds for Kids Corporate Volunteers"
          src={hero}
          className="absolute z-0 h-full w-full object-cover object-center"
          sizes="100vw"
          priority
        />
        <div className="pointer-events-none absolute -bottom-[1px] left-0 right-0">
          <BlueArch />
        </div>
      </section>
      <section className="text-white-500 bg-blue-500 pb-16">
        <div className="items-center px-4 pt-12">
          <div className="text-center text-xl leading-7">
            <p className="mx-auto my-8 font-avenir text-2xl font-semibold leading-10 text-white md:my-6">
              Thank you to all who joined us for our ribbon-cutting celebration!
              <br />
              Your support makes our mission possible.
            </p>
          </div>
        </div>
        <div className="m-12 flex justify-center pt-12">
          <iframe
            className="aspect-[800/450] w-full max-w-[800px]"
            src="https://www.wcnc.com/embeds/video/responsive/275-7bd74d5b-29bc-4b8b-b8dc-3933cf27ff8b/iframe"
            allowFullScreen></iframe>
        </div>
      </section>
      <section className="mx-8 bg-white pb-12 text-black">
        <div className="flex flex-col items-center justify-center gap-4 pt-12 md:flex-row md:px-4">
          <A href="/" className="my-4 flex-shrink">
            <LogoMain className="w-32 md:w-24" />
          </A>
          <div className="flex flex-grow flex-col gap-3 text-center text-base">
            <div>
              <A external href="mailto:info@bedsforkids.org" className="font-avenir font-semibold hover:underline">
                info@bedsforkids.org
              </A>
            </div>
            <div>
              <A external href="tel:+19804221192" className="font-avenir font-semibold hover:underline">
                (980) 422-1192
              </A>
            </div>
            <div>
              <p className="font-avenir font-semibold">Warehouse Address:</p>
              <A
                external
                href="https://maps.app.goo.gl/LqDLU5MtH3mp8TkE8"
                className="font-avenir leading-6 hover:underline">
                2701-A Hutchison McDonald Rd., <br className="md:hidden" /> Charlotte, NC 28269
              </A>
            </div>
          </div>

          <div className="my-4 flex flex-shrink justify-center gap-4 md:my-auto md:w-auto">
            <A external href="https://www.instagram.com/bedsforkids/">
              <InstagramIcon className="h-7 w-7" />
            </A>
            <A external title="LinkedIn" href="https://www.linkedin.com/company/beds-for-kids/">
              <FaLinkedin className="h-7 w-7" />
            </A>
            <A external title="Facebook" href="https://www.facebook.com/bedsforkids">
              <FaFacebookF className="h-7 w-7" />
            </A>
            <A external title="YouTube" href="https://www.youtube.com/@bedsforkids2134">
              <FaYoutube className="h-7 w-7" />
            </A>
          </div>
        </div>
      </section>
    </main>
  );
}
